export const information = `
### Welcome to Neighborhood Intel!

**Neighborhood Intel** cleans, integrates, and visualizes your data, providing you with insights about neighborhood and economic health that help you quantify the impact your work has on the community, collaborate with stakeholders, and tell the story of your success.

Use [this guide](https://f.hubspotusercontent30.net/hubfs/6216183/_User%20Manuals/Neighborhood%20Intel%20User%20Manual.pdf) for instructions on getting started and tips on how to best use your account.

If you need help, your account manager can be reached at [support@munetrix.com](mailto:support@munetrix.com).
`;
